<template>
  <span
    class="best-pick-pill"
    :style="{
      color: sorting_options[value].color,
      background: sorting_options[value].background,
    }"
  >
    <span style="font-size: 50px; line-height: 0.1"> &middot; </span>
    <span class="semibold">
      {{ sorting_options[value].description }}
    </span>
  </span>
</template>

<script>
import { sorting_options } from '@/utilities/sorting';

export default {
  name: 'best-pick-pill',
  props: {
    value: String,
  },
  data() {
    return {
      sorting_options,
    };
  },
};
</script>

<style lang="scss" scoped>
.best-pick-pill {
  display: flex;
  align-items: center;
  padding: 2px 7.5px 2px 2px;
  border-radius: 15px;
  line-height: normal;
  gap: 2px;
  font-size: 12px;
}
</style>
